import { FC, memo } from "react";
import { SIDE } from "_constants";
import { StatusMessageBase } from "components/common/StatusMessageBase";

type Props = {
  className?: string;
  team?: string | null;
  side: SIDE;
  Icon?: React.ComponentType<any>;
  title?: string;
  description?: string;
  normalizedCode: string;
  status: any;
  width: number;
  height: number;
};

export const StatusMessage: FC<Props> = memo((props) => {
  const bottomCodes = ["1270", "1295"]; // On Possession / In Possession

  const sideIconResolver = (normalizedCode: string, side: "home" | "away") => {
    const { Icon } = props;
    const rotateCodes = [
      "1270", // On Possession
      "1295", // In Possession
      "1273", // Shot
      "1275", // Penalty Shot
    ];
    const isHome = side === "home";

    if (Icon && isHome && rotateCodes.includes(normalizedCode)) {
      const Flipped: React.FC = () => (
        <div className="origin-center scale-x-[-1]">
          <Icon />
        </div>
      );
      return Flipped;
    }
    return Icon ?? null;
  };

  return (
    <StatusMessageBase
      {...props}
      bottomCodes={bottomCodes}
      accentColor="#123649"
      sideIconResolver={sideIconResolver}
    />
  );
});
